import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { DEMO_MODE } from "./demo-mode";

/** `bar` — pasek na całą szerokość treści; `card` — kafel wewnątrz karty logowania. */
export type DemoNoticeVariant = "bar" | "card";

@Component({
  selector: "app-demo-notice",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  // Pasek ma zostać widoczny także po przewinięciu treści — `main` w powłoce jest kontenerem scrolla.
  host: { "[class.demo-notice-host--sticky]": "variant() === 'bar'" },
  templateUrl: "./demo-notice.html",
  styleUrl: "./demo-notice.scss",
})
export class DemoNotice {
  protected readonly demoMode = inject(DEMO_MODE);

  readonly variant = input<DemoNoticeVariant>("bar");

  /** Dodaje zdanie o pozornym logowaniu — tylko na ekranie logowania. */
  readonly loginHint = input(false, { transform: booleanAttribute });
}
